import { PointsLedgerProvider, usePointsLedger } from './getPointsLedger.query'

export const RewardsGQL = {
  PointsLedgerProvider,
  usePointsLedger,
}
